import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.33262 5.06309L9.33262 2.87559C9.75849 2.68928 10.2428 2.68928 10.6687 2.87559L15.6687 5.06309C16.2753 5.3285 16.6673 5.92786 16.6673 6.59002V11.3333C16.6673 15.0152 13.6825 18 10.0007 18C6.31875 18 3.33398 15.0152 3.33398 11.3333V6.59002C3.33398 5.92786 3.72597 5.3285 4.33262 5.06309Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.5 10.5L9.16667 12.1667L12.5 8.83337",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }